// Mock data for furniture cleaning page

export const furnitureBeforeAfter = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/v8c6z79b_IMG_5426.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/v8c6z79b_IMG_5426.JPG",
    title: "Canapé avec Taches",
    description: "Élimination complète des taches tenaces"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/1wopbl03_IMG_5427.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/1wopbl03_IMG_5427.JPG",
    title: "Fauteuil Beige",
    description: "Nettoyage en profondeur et rafraîchissement"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/c7azfpof_IMG_5428.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/c7azfpof_IMG_5428.JPG",
    title: "Tapis Décoratif",
    description: "Restauration et nettoyage complet"
  },
  {
    id: 4,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/e7ctnt7n_IMG_5429.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/e7ctnt7n_IMG_5429.JPG",
    title: "Matelas Double",
    description: "Hygiénisation et désinfection"
  },
  {
    id: 5,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/x91npvuc_IMG_5430.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/x91npvuc_IMG_5430.JPG",
    title: "Canapé d'Angle",
    description: "Nettoyage professionnel complet"
  },
  {
    id: 6,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/svrygzif_IMG_5431.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/svrygzif_IMG_5431.JPG",
    title: "Canapé d'Angle Détail",
    description: "Transformation spectaculaire"
  }
];

export const furnitureServices = [
  {
    id: 1,
    name: "Fauteuil",
    price: "39€",
    description: "Nettoyage professionnel de votre fauteuil",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Traitement des taches",
      "Désinfection",
      "Déplacement inclus"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Canapé 2 Places",
    price: "59€",
    description: "Nettoyage en profondeur de votre canapé 2 places",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Traitement des taches tenaces",
      "Désinfection complète",
      "Déplacement inclus"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Canapé 3 Places",
    price: "79€",
    description: "Nettoyage complet de votre canapé 3 places",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Traitement des taches",
      "Désinfection",
      "Rafraîchissement du tissu",
      "Déplacement inclus"
    ],
    popular: false
  },
  {
    id: 4,
    name: "Canapé d'Angle",
    price: "119€",
    description: "Prestation complète pour canapé d'angle",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Traitement intensif des taches",
      "Désinfection complète",
      "Rafraîchissement",
      "Déplacement inclus"
    ],
    popular: false
  },
  {
    id: 5,
    name: "Matelas 1 Place",
    price: "49€",
    description: "Hygiénisation de votre matelas 1 place",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Élimination des acariens",
      "Désinfection",
      "Déplacement inclus"
    ],
    popular: false
  },
  {
    id: 6,
    name: "Matelas 2 Places",
    price: "79€",
    description: "Nettoyage complet de votre matelas double",
    features: [
      "Aspiration complète",
      "Shampoing professionnel",
      "Élimination des acariens",
      "Désinfection profonde",
      "Traitement anti-bactérien",
      "Déplacement inclus"
    ],
    popular: false
  },
  {
    id: 7,
    name: "Tapis",
    price: "dès 29€",
    description: "Nettoyage de tapis de toutes tailles",
    features: [
      "Aspiration des deux faces",
      "Shampoing adapté au tissu",
      "Traitement des taches",
      "Séchage rapide",
      "Déplacement inclus",
      "Tarif selon dimensions"
    ],
    popular: false
  }
];

export const packPromotions = {
  twoServices: {
    discount: "10€",
    description: "Réduction de 10€ pour 2 services"
  },
  threeServices: {
    discount: "20€",
    description: "Réduction de 20€ pour 3 services ou plus"
  }
};

export const furnitureTestimonials = [
  {
    id: 1,
    name: "Claire B.",
    location: "Bordeaux",
    rating: 5,
    text: "Mon canapé était couvert de taches et maintenant il est comme neuf ! Service impeccable et très professionnel."
  },
  {
    id: 2,
    name: "Laurent M.",
    location: "Talence",
    rating: 5,
    text: "Excellent travail sur mon matelas. L'odeur est fraîche et toutes les taches ont disparu. Je recommande !"
  },
  {
    id: 3,
    name: "Isabelle D.",
    location: "Mérignac",
    rating: 5,
    text: "Service à domicile très pratique. Mon tapis et mon canapé sont impeccables. Prix très correct."
  }
];

export const furnitureBenefits = [
  {
    id: 1,
    title: "Service à Domicile",
    description: "Nous venons chez vous avec tout notre équipement professionnel"
  },
  {
    id: 2,
    title: "Produits Professionnels",
    description: "Utilisation de produits adaptés à chaque type de tissu"
  },
  {
    id: 3,
    title: "Hygiène Garantie",
    description: "Élimination des acariens, bactéries et mauvaises odeurs"
  },
  {
    id: 4,
    title: "Déplacement Inclus",
    description: "Pas de frais supplémentaires sur Bordeaux et 40km autour"
  }
];
